<script lang="ts" setup>
import TextareaPrime, { type TextareaEmits, type TextareaProps } from 'primevue/textarea'

interface Props extends /* @vue-ignore */ TextareaProps {
  error?: boolean
}
// eslint-disable-next-line @typescript-eslint/no-empty-object-type
interface Emits extends /* @vue-ignore */ TextareaEmits {}
defineProps<Props>()
defineEmits<Emits>()

const model = defineModel<Props['modelValue'] | null>()

const errorInjected = inject<Ref<boolean>>('error', ref(false))
</script>

<template>
  <TextareaPrime
    v-bind="$props"
    v-model="model"
    :invalid="errorInjected || error"
  />
</template>
